<template>
  <div class="select">
    <div class="content" id="sifaList">
      <div class="clearFix project-detail-nav">
        <div class="search-nav-item searchText">
          <span></span><i class="close" v-on:click="clickClose0($event)"></i>
        </div>
        <div class="search-nav-item province">
          <span></span><i class="close" v-on:click="clickClose1($event)"></i>
        </div>
        <div class="search-nav-item hungaifangshi">
          <span></span><i class="close" v-on:click="clickClose2($event)"></i>
        </div>
        <div class="search-nav-item touzibili">
          <span></span><i class="close" v-on:click="clickClose3($event)"></i>
        </div>
        <div class="search-nav-item touzijine">
          <span></span><i class="close" v-on:click="clickClose4($event)"></i>
        </div>
        <div class="search-nav-item xiangmuzhuangtai">
          <span></span><i class="close" v-on:click="clickClose5($event)"></i>
        </div>
        <div class="search-nav-item hangyefenlei">
          <span></span><i class="close" v-on:click="clickClose6($event)"></i>
        </div>
        <div class="search-nav-item redianbiaoqian">
          <span></span><i class="close" v-on:click="clickClose7($event)"></i>
        </div>
        <div class="search-nav-item jigou">
          <span></span><i class="close" v-on:click="clickClose8($event)"></i>
        </div>
        <div class="top-right">
          <input id="searchText" placeholder="请输入项目关键字">
          <a href="javascript:void(0)" v-on:click="clickSearch($event)">
            搜索
          </a>
        </div>
      </div>
      <div class="card_type">
        <dl class="l-fix" style="line-height:46px;">
          <dt>
            热点标签
          </dt>
          <dd>
            <div class="dd-redianbiaoqian" style="">
              <a class="on" v-on:click="clickTag($event)" data-code="" href="javascript:void(0)">全部</a>
              <a v-for="tag in tagList" v-on:click="clickTag($event)" v-bind:data-code="tag.tagcode" href="javascript:void(0)">{{tag.tagname}}</a>
            </div>
          </dd>
        </dl>
        <dl class="l-fix" style="line-height:46px;">
          <dt>
            所在地区
          </dt>
          <dd>
            <a class="more" v-on:click="clickMore($event)">
              <i class="down"></i>
            </a>
            <ul class="clearFix sheng" style="width:1020px;height:46px;overflow: hidden;">
              <li class="province" v-on:click="clickProvince($event)">
                <a class="on" href="javascript:void(0)"><span>全国</span></a>
              </li>
              <li class="province " v-for="area in areaList" v-on:click="clickProvince($event)"><a
                href="javascript:void(0)"><span>{{area.tagname}}</span></a></li>
            </ul>
          </dd>
        </dl>
        <dl class="l-fix">
          <dt>
            混改方式
          </dt>
          <dd class="dd-hungaifangshi">
            <a class="on" v-on:click="clickFangshi($event)" href="javascript:void(0)">全部</a>
            <a v-on:click="clickFangshi($event)" data-code="C02" href="javascript:void(0)">股权转让</a>
            <a v-on:click="clickFangshi($event)" data-code="C03" href="javascript:void(0)">增资扩股</a>
            <a v-on:click="clickFangshi($event)" data-code="C08" href="javascript:void(0)">新设</a>
            <a v-on:click="clickFangshi($event)" data-code="C07" href="javascript:void(0)">其他</a>
          </dd>
        </dl>
        <dl class="l-fix">
          <dt>
            投资比例
          </dt>
          <dd class="dd-touzibili">
            <a class="on" v-on:click="clickBili($event)" data-min="" data-max="" href="javascript:void(0)">全部</a>
            <a v-on:click="clickBili($event)" data-min="0" data-max="5" href="javascript:void(0)"> 5%以下</a>
            <a v-on:click="clickBili($event)" data-min="6" data-max="10" href="javascript:void(0)"> 6%-10%</a>
            <a v-on:click="clickBili($event)" data-min="11" data-max="33" href="javascript:void(0)">11%-33%</a>
            <a v-on:click="clickBili($event)" data-min="34" data-max="50" href="javascript:void(0)">34%-50%</a>
            <a v-on:click="clickBili($event)" data-min="51" data-max="67" href="javascript:void(0)">51%-67%</a>
            <a v-on:click="clickBili($event)" data-min="68" data-max="" href="javascript:void(0)">68%以上</a>
          </dd>
        </dl>
        <dl class="l-fix">
          <dt>
            投资金额
          </dt>
          <dd class="dd-touzijine">
            <a class="on" v-on:click="clickJine($event)" data-min="" data-max="" href="javascript:void(0)">全部</a>
            <a v-on:click="clickJine($event)" data-min="0" data-max="500" href="javascript:void(0)">500万以下</a>
            <a v-on:click="clickJine($event)" data-min="500" data-max="1000" href="javascript:void(0)">500-1000万</a>
            <a v-on:click="clickJine($event)" data-min="1000" data-max="5000" href="javascript:void(0)">1000-5000万</a>
            <a v-on:click="clickJine($event)" data-min="5000" data-max="10000" href="javascript:void(0)">5000-10000万</a>
            <a v-on:click="clickJine($event)" data-min="10000" data-max="" href="javascript:void(0)">1亿以上</a>
          </dd>
        </dl>
        <dl class="l-fix">
          <dt>
            项目状态
          </dt>
          <dd class="dd-xiangmuzhuangtai">
            <a class="on" v-on:click="clickZhuangtai($event)" data-code="" href="javascript:void(0)">全部</a>
            <a v-on:click="clickZhuangtai($event)" data-code="A01" href="javascript:void(0)">预挂牌</a>
            <a v-on:click="clickZhuangtai($event)" data-code="A02" href="javascript:void(0)">正式挂牌</a>
            <a v-on:click="clickZhuangtai($event)" data-code="A05" href="javascript:void(0)">意向挂牌</a>
<!--            <a v-on:click="clickZhuangtai($event)" data-code="A06" href="javascript:void(0)">已成交</a>-->
          </dd>
        </dl>
        <dl class="l-fix" style="line-height:46px;">
          <dt>
            行业分类
          </dt>
          <dd class="industry-no-border">
            <a class="more" v-on:click="clickMore($event)">
              <i class="down"></i>
            </a>
            <div class="dd-hangyefenlei" style="height:46px;overflow: hidden;">
              <a class="on" v-on:click="clickHangye($event)" data-code="" href="javascript:void(0)">全部</a>
              <a v-on:click="clickHangye($event)" data-code="J" href="javascript:void(0)">金融业</a>
              <a v-on:click="clickHangye($event)" data-code="A" href="javascript:void(0)">农、林、牧、渔业</a>
              <a v-on:click="clickHangye($event)" data-code="B" href="javascript:void(0)">采矿业</a>
              <a v-on:click="clickHangye($event)" data-code="C" href="javascript:void(0)">制造业</a>
              <a v-on:click="clickHangye($event)" data-code="D" href="javascript:void(0)">电力、热力、燃气及水生产和供应业</a>
              <a v-on:click="clickHangye($event)" data-code="E" href="javascript:void(0)">建筑业</a>
              <a v-on:click="clickHangye($event)" data-code="F" href="javascript:void(0)">批发和零售业</a>
              <a v-on:click="clickHangye($event)" data-code="G" href="javascript:void(0)">交通运输、仓储和邮政业</a>
              <a v-on:click="clickHangye($event)" data-code="H" href="javascript:void(0)">住宿和餐饮业</a>
              <a v-on:click="clickHangye($event)" data-code="I" href="javascript:void(0)">信息传输、软件和信息技术服务业</a>
              <a v-on:click="clickHangye($event)" data-code="K" href="javascript:void(0)">房地产业</a>
              <a v-on:click="clickHangye($event)" data-code="L" href="javascript:void(0)">租赁和商务服务业</a>
              <a v-on:click="clickHangye($event)" data-code="M" href="javascript:void(0)">科学研究和技术服务业</a>
              <a v-on:click="clickHangye($event)" data-code="N" href="javascript:void(0)">水利、环境和公共设施管理业</a>
              <a v-on:click="clickHangye($event)" data-code="O" href="javascript:void(0)">居民服务、修理和其他服务业</a>
              <a v-on:click="clickHangye($event)" data-code="P" href="javascript:void(0)">教育</a>
              <a v-on:click="clickHangye($event)" data-code="Q" href="javascript:void(0)">卫生和社会工作</a>
              <a v-on:click="clickHangye($event)" data-code="R" href="javascript:void(0)">文化、体育和娱乐业</a>
              <a v-on:click="clickHangye($event)" data-code="S" href="javascript:void(0)">公共管理、社会保障和社会组织</a>
            </div>
          </dd>
        </dl>
        <dl class="l-fix" style="line-height:46px;" id="tradingFirms">
          <dt>
            交易机构
          </dt>
          <dd>
            <a class="more" v-on:click="clickMoreJigou($event)">
              <i class="down"></i>
            </a>
            <div class="dd-jigou" style="height:46px;overflow: hidden;">
              <a class="on" v-on:click="clickJigou($event)" data-code="" href="javascript:void(0)">全部</a>
              <a v-on:click="clickJigou($event)" v-for="org in orgList" v-bind:data-code="org.orgid" href="javascript:void(0)">{{org.name}}</a>
            </div>
          </dd>
        </dl>

      </div>
      <div class="clearFix search-nav">
        <div class="search-nav-left">
          <a class="active" v-on:click="clickNew($event)" href="javascript:void(0);">最新</a>
          <a v-on:click="clickHot($event)" href="javascript:void(0);">热点项目</a>
          <a v-on:click="clickPriceSort($event)" href="javascript:void(0);">
            价格<i class="down"></i>
          </a>
        </div>
        <div class="search-nav-right">
          共有<span>{{total}}</span>条符合条件的数据
        </div>
      </div>
      <ul id="gzlist" class="clearFix" v-if="total>0" style="padding-bottom: 40px;">
        <li class="project-list" style="overflow:hidden;" v-for="(assets,index) in item">
          <div class="project-status orange" v-if="assets.businessStatus=='A01'">
            预挂牌
          </div>
          <div class="project-status" v-else-if="assets.businessStatus=='A02'">
            正式挂牌
          </div>
          <div class="project-status blue" v-else-if="assets.businessStatus=='A05'">
            意向挂牌
          </div>
          <div class="project-status gray" v-else-if="assets.businessStatus=='A06'">
            已成交
          </div>
          <div style="height:24px;" v-else></div>

          <div class="proBox l-fix">
            <div class="slBox">
              <h3>
                <a target="_blank" v-if="assets.businessStatus=='A05'">
                  <router-link target="_blank" :to="{path:'/projectDetail',query: {id: assets.id}}">
                    {{assets.projectName|maxLength50}}
                  </router-link>
                </a>
                <a v-else href="javascript:void(0)" v-on:click="openNewWindowNoreferrer($event,assets.Projecturl)">
                  {{assets.projectName|maxLength50}}
                </a>
                <!--<a v-else target="_blank" rel="noreferrer">
                  <router-link target="_blank" :to="{path:'/jump',query: {url: assets.Projecturl,orgname:assets.tradInstitutionName}}" rel="noreferrer">
                    {{assets.projectName|maxLength50}}
                  </router-link>
                </a>-->
              </h3>
              <div class="clearFix">
                <div class="project-content-left" v-if="assets.businessStatus=='A06'&&assets.tradeValue!=''">
                  <!-- A06已成交-->
                  成交价格：<span class="price">{{assets.tradeValue}}</span>
                  <span v-if="assets.tradeValue!='面议'">万元</span>
                </div>
                <div class="project-content-left" v-else-if="assets.businessStatus=='A05'">
                  <!-- A05意向-->
                  挂牌价格：<span class="price" v-if="assets.projectPrice!='' && assets.projectPrice!=null && assets.projectPrice!=0">{{assets.projectPrice}}</span>
                  <span v-else-if="assets.projectPrice=='' || assets.projectPrice==null || assets.projectPrice==0">待定</span>
                  <span v-if="assets.projectPrice!='面议'&&assets.projectPrice!=''&&assets.projectPrice!=0&&assets.projectPrice!=null">万元</span>
                </div>
                <div class="project-content-left" v-else>
                  挂牌价格：<span class="price" v-if="assets.projectPrice!='' && assets.projectPrice!=null && assets.projectPrice!=0">{{assets.projectPrice}}</span>
                  <span v-else-if="assets.projectPrice=='' || assets.projectPrice==null || assets.projectPrice==0">待定</span>
                  <span v-if="assets.projectPrice!='面议'&&assets.projectPrice!=''&&assets.projectPrice!=0&&assets.projectPrice!=null">万元</span>
                </div>
                <div class="project-content-right" v-if="assets.projectClassifyCode=='C02'&&assets.sellPercent!=''">
                  <!--C02股权转让-->
                  转让比例：{{assets.sellPercent|filPercent}}
                </div>
                <div class="project-content-right" v-else-if="assets.projectClassifyCode=='C03'&&assets.projectPrice!=''">
                  <!--C03增资扩股-->
                  拟融资金额：
                  <span v-if=" assets.projectPrice!=null && assets.projectPrice!=0">{{assets.projectPrice}}</span>
                  <span v-else-if="assets.projectPrice=='' || assets.projectPrice==null || assets.projectPrice==0">待定</span>
                  <span v-if="assets.projectPrice!='面议'&&assets.projectPrice!=''&&assets.projectPrice!=0&&assets.projectPrice!=null">万元</span>
                </div>
                <div class="project-content-right" v-else>

                </div>
              </div>
              <div class="clearFix">
                <!-- A06已成交，A05意向挂牌-->
                <div class="project-content-left"
                     v-if="assets.businessStatus=='A06' && assets.tradeDate!='' && assets.tradeDate!=undefined">
                  成交时间：{{assets.tradeDate|dateFormat}}
                </div>
                <div class="project-content-left" v-else-if="assets.businessStatus=='A05' && assets.publishDate!='' && assets.publishDate!=undefined">
                  挂牌时间：{{assets.publishDate|dateFormat}}
                </div>
                <div class="project-content-left" v-else-if="assets.publishDate!='' && assets.publishDate!=undefined && assets.expireDate!='' && assets.expireDate!=undefined">
                  挂牌时间：{{assets.publishDate|dateFormat}} 至 {{assets.expireDate|dateFormat}}
                </div>
                <div class="project-content-left" v-else-if="(assets.publishDate=='' || assets.publishDate==undefined) && assets.expireDate!='' && assets.expireDate!=undefined">
                  挂牌截止时间：{{assets.expireDate|dateFormat}}
                </div>
                <div class="project-content-right">
                  <div class="industry"
                       v-if="assets.industryCode!=''&&assets.industryCode!=undefined&&assets.indutry_code!=assets.industryCode">
                    {{assets.industryCode}}
                  </div>
                  <div v-else></div>
                </div>
              </div>
              <div class="project-address">
                <div class="project-address-left" v-if="assets.tagName!=''&&assets.tagName!=undefined">
                   <i></i>{{assets.tagName}}
                </div>
                <div class="project-address-right">
                  <div class="erweima-div" v-if="assets.businessStatus=='A05'" v-bind:data-type="assets.businessStatus" v-bind:data-url="'#/projectDetail?id='+assets.id" v-bind:id="'code-'+index"></div>
                  <div class="erweima-div" v-else v-bind:data-type="assets.businessStatus" v-bind:data-url="assets.Projecturl" v-bind:id="'code-'+index"></div>
                  <a class="share" v-on:click="share($event)" href="JavaScript:void(0)"><i></i>点击分享</a>
                  <span style="margin-left:20px;" v-if="assets.zoneName!=''&&assets.zoneName!=undefined">
                    <i></i>{{assets.zoneName}}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </li>
      </ul>
      <div style="text-align: center;margin-top:50px;" v-else-if="total==0">
        <img src="../assets/no-data.png">
      </div>
      <div id="projectPromptInfo" style="text-align: center;color:#666;margin-top:20px;margin-bottom: 20px;"></div>
      <div class="to-top" style="display: none" v-on:click="toTop()">
        <img src="../assets/top.png">
      </div>
    </div>

  </div>
</template>

<script>
  // 导入轮播图组件
  import {swiper, swiperSlide} from 'vue-awesome-swiper'
  // 导入vuex
  import {mapState, mapMutations, mapActions} from 'vuex'
  import QRCode from 'qrcodejs2'  // 引入qrcode
  import global from '../components/public/Common.vue';

  export default {
    computed: {
      /**
       * @desc 从store中引入需要的数据
       */

    },
    watch: {
      //"$route":this.getProjectData()
      '$route'(to, from) {
        this.$router.go(0);
      }
    },
    created: function () {
      //created和mounted区别，在created的时候，视图中的html并没有渲染出来，所以此时如果直接去操作html的dom节点，一定找不到相关的元素
      //而在mounted中，由于此时html已经渲染出来了，所以可以直接操作dom节点
      let _this = this;
      //_this.$emit('header',false);//控制不显示头部（北部湾）
      //_this.$emit('footer',false);//控制不显示尾部（北部湾）

      if (_this.$route.query.searchText != "" && _this.$route.query.searchText != undefined) {
        requestSearch.searchText = _this.$route.query.searchText
      }

      //查询地区和热点标签和广告
      $.ajax({
        url: _this.tagListUrl,
        type: 'post',
        dataType: 'jsonp',
        data: {token:global.token,"orgid":global.orgid},
        success: function (data) {
          if (data.msg == 200) {
            delete requestSearch.start;
            //第一次进页面查询地区
            _this.areaList = data.result.data.loc;
            _this.tagList = data.result.data.tag;
            if(data.result.data.filter[0].filter==null || data.result.data.filter[0].filter==""){
               $("#tradingFirms").css("display","none");
              $(".industry-no-border").css("border-bottom","0");
            }else if(data.result.data.filter[0].filter==1){
              $("#tradingFirms").css("display","block");
              _this.orgList = data.result.data.orgs;
            }
          } else {
            alert(data.msg);
          }
        },
        error: function (data) {

        }
      });

      //查询项目
      $.ajax({
        url: _this.projectUrl,
        type: 'post',
        dataType: 'jsonp',
        data: requestSearch,
        success: function (data) {
          if (data.msg == 200) {
            delete requestSearch.start;
            //第一次进页面查询项目
            _this.total = data.result.totalData;
            _this.item = data.result.data;

          } else {
            alert(data.msg);
          }
        },
        error: function (data) {

        }
      });


      /**
       * @desc 判断是否显示回到顶部的图标
       */
      $(window).scroll(function(){
        if($(window).scrollTop()<1000){
          $(".to-top").hide();
        }else{
          $(".to-top").show();
        }
      });

      //window.addEventListener('scroll', this.scrollEnd);//下拉加载数据
      if (document.addEventListener) {
        //webkit
        document.addEventListener('mousewheel', this.scrollEnd, false);//鼠标滚轮事件
        //firefox
        document.addEventListener('DOMMouseScroll', this.scrollEnd, false);

      }else if(window.attachEvent){//IE
        document.attachEvent('onmousewheel',this.scrollEnd);
      }

      //触摸屏下拉加载
      var startX;                     //触摸起始横坐标
      var startY;                    //触摸起始纵坐标
      var moveSpave;                //移动的距离
      var isMoveX = true;          //判断是否为左右移动
      var isFirst = true;          //是否要判断touchmove方向
      var beginTime = 0;
      //监听 触摸事件
      document.querySelector("body").addEventListener('touchstart', function (event) {
        startX = event.targetTouches[0].pageX; //触摸起始位置赋值 相对于屏幕的 横向坐标
        startY = event.targetTouches[0].pageY; //触摸起始位置赋值 相对于屏幕的 纵向坐标
        isFirst = true;
        beginTime = new Date().getTime();
      });
      //监听 触摸滑动事件
      document.querySelector("body").addEventListener('touchmove', function (e) {
        var moveX = e.targetTouches[0].pageX; //触摸的位置   相对于屏幕的 横向坐标
        var moveY = e.targetTouches[0].pageY; //触摸的位置   相对于屏幕的 纵向坐标
        if (isFirst) {
          Math.abs(moveX - startX) - Math.abs(moveY - startY) >= 2 ? isMoveX = true : isMoveX = false;
          isFirst = false;
          //return;
        }
        if (isMoveX) {
          //水平滑动
          moveSpave = moveX - startX;
        } else {
          //竖直滑动
          moveSpave = moveY - startY;
          if (moveSpave > 0) {
            //$('.preloader').addClass('visible');
          } else {
            //$('.addajax').addClass('visible');
          }
        }
      });

      //监听触摸离开事件
      document.querySelector("body").addEventListener('touchend', function (e) {
        var endtime = new Date().getTime();
        if ((endtime - beginTime) < 100) {
          //时间小于0.1秒
          return;
        } else {
          if (isMoveX) { //当是水平拖动操作的时候
            if (moveSpave < 0) {
            } else if (moveSpave > 0) {
            }
          } else {
            //alert("垂直拖动");
            if (moveSpave < 0) {  //向上滑动
              //alert("000");
              if (_this.noMore) {
                return false;
              }
              if (!_this.lock) {
                _this.lock = true;//锁住
                _this.getMore();
              }
            } else if (moveSpave > 0) { //向下滑动  加载数据}
            }
          }
        }
      });

    },
    destroyed() {
      //window.removeEventListener('scroll', this.scrollEnd);//监听页面滚动事件
    },
    components: {
      swiper,
      swiperSlide
    },
    //el: '#sifaList',
    name: 'projectList',
    data() {
      return {
        projectUrl:global.projectUrl,
        tagListUrl:global.tagListUrl,
        item: [],
        total: "",
        noMore: false,    //true没有更多了
        lock: false,       //锁，防止滚动到最后时多次执行加载
        areaList:[],
        tagList:[],
        orgList:[]
      }
    },
    methods: {
      isIE: function () {
        if (!!window.ActiveXObject || "ActiveXObject" in window)
          return true;
        else
          return false;
      },
      ieNorefererOpen: function (url, blankurl) {
        //ie不带referer打开url，url要打开的链接，blankurl指向一个空页面
        if (blankurl === undefined) {
          //blankurl = null;
          blankurl = "index.html#/select";
        }

        var win = window.open(blankurl, '_blank');
        var doc = win.document;
        doc.clear();
        doc.write('<html><head><meta http-equiv="Refresh" content="0; URL=' + url + '"/></head><body></body></html>');
        doc.close();
      },
      openNewWindowNoreferrer: function (a, full_link) {
        if (this.isIE()) {
          $(a.currentTarget).attr("rel","noreferrer");
          $(a.currentTarget).attr("target","_self");
          this.ieNorefererOpen(full_link);
        } else {
          $(a.currentTarget).attr("rel","noreferrer");
          $(a.currentTarget).attr("target","_blank");
          $(a.currentTarget).attr("href",full_link);
        }
      },
      jumpTo: function (event) {
        $(event.currentTarget).attr("target","_blank");
        var ctx="https://cqjy.qdcq.net//portal";
        var jumpUrl = $(event.currentTarget).attr("data-url");
        if(global.orgid=='ins_040'){
          //青岛
          $(event.currentTarget).attr("href",ctx+"https://cqjy.qdcq.net//portal/page?to='proUtrg&amp;proId=3a2f901ea07b453aba9b1c1786030d45&amp;packId='");
        }

        //function doSendPage(toPage){window.location=ctx+"/page?to="+toPage;}
        //function doOpenPage(att,toPage){att.target="_blank";att.href=ctx+"/page?to="+toPage;}
      },
      share: function (event) {
        var codeId = $(event.currentTarget).prev().attr("id");
        var dataUrl = $(event.currentTarget).prev().attr("data-url");
        var dataType = $(event.currentTarget).prev().attr("data-type");
        if(dataType=="A05"){
          dataUrl = window.location.href.split("#")[0] + dataUrl;
        }
        $(event.currentTarget).prev().toggle();
        $(event.currentTarget).prev().html("");
        let qrcode = new QRCode(codeId, {
          width: 80,
          height: 80,
          text: dataUrl, // 二维码地址
          colorDark : "#000",
          colorLight : "#fff",
        })
      },
      clickProvince: function (event) {
        $(event.currentTarget).find("a").addClass("on");
        $(event.currentTarget).siblings().find("a").removeClass('on');
        if ($(event.currentTarget).find("a span").text() == "全国") {
          delete requestSearch.zone;
          $(".search-nav-item.province").css("display", "none").find("span").html("");
        } else {
          requestSearch.zone = $(event.currentTarget).find("a span").text();
          $(".search-nav-item.province").css("display", "inline-block").find("span").html(requestSearch.zone);
        }
        this.getProjectData();
      },
      clickFangshi: function (event) {
        $(event.currentTarget).addClass("on").siblings().removeClass('on');
        if ($(event.currentTarget).text() == "全部") {
          delete requestSearch.classify;
          $(".search-nav-item.hungaifangshi").css("display", "none").find("span").html("");
        } else {
          requestSearch.classify = $(event.currentTarget).attr("data-code");
          $(".search-nav-item.hungaifangshi").css("display", "inline-block").find("span").html($(event.currentTarget).text());
        }
        this.getProjectData();

      },
      clickBili: function (event) {
        $(event.currentTarget).addClass("on").siblings().removeClass('on');
        if ($(event.currentTarget).text() == "全部") {
          delete requestSearch.minpercent;
          delete requestSearch.maxpercent;
          $(".search-nav-item.touzibili").css("display", "none").find("span").html("");
        } else {
          requestSearch.minpercent = $(event.currentTarget).attr("data-min");
          requestSearch.maxpercent = $(event.currentTarget).attr("data-max");
          $(".search-nav-item.touzibili").css("display", "inline-block").find("span").html($(event.currentTarget).text());
        }
        this.getProjectData();
      },
      clickJine: function (event) {
        $(event.currentTarget).addClass("on").siblings().removeClass('on');
        if ($(event.currentTarget).text() == "全部") {
          delete requestSearch.minprice;
          delete requestSearch.maxprice;
          $(".search-nav-item.touzijine").css("display", "none").find("span").html("");
        } else {
          requestSearch.minprice = $(event.currentTarget).attr("data-min");
          requestSearch.maxprice = $(event.currentTarget).attr("data-max");
          $(".search-nav-item.touzijine").css("display", "inline-block").find("span").html($(event.currentTarget).text());
        }
        this.getProjectData();
      },
      clickZhuangtai: function (event) {
        $(event.currentTarget).addClass("on").siblings().removeClass('on');
        if ($(event.currentTarget).text() == "全部") {
          delete requestSearch.state;
          $(".search-nav-item.xiangmuzhuangtai").css("display", "none").find("span").html("");
        } else {
          requestSearch.state = $(event.currentTarget).attr("data-code");
          $(".search-nav-item.xiangmuzhuangtai").css("display", "inline-block").find("span").html($(event.currentTarget).text());
        }
        this.getProjectData();
      },
      clickHangye: function (event) {
        $(event.currentTarget).addClass("on").siblings().removeClass('on');
        if ($(event.currentTarget).text() == "全部") {
          delete requestSearch.industry;
          $(".search-nav-item.hangyefenlei").css("display", "none").find("span").html("");
        } else {
          requestSearch.industry = $(event.currentTarget).attr("data-code");
          $(".search-nav-item.hangyefenlei").css("display", "inline-block").find("span").html($(event.currentTarget).text());
        }
        this.getProjectData();
      },
      clickJigou: function (event) {
        $(event.currentTarget).addClass("on").siblings().removeClass('on');
        if ($(event.currentTarget).text() == "全部") {
          delete requestSearch.orgid;
          $(".search-nav-item.jigou").css("display", "none").find("span").html("");
        } else {
          requestSearch.orgid = $(event.currentTarget).attr("data-code");
          $(".search-nav-item.jigou").css("display", "inline-block").find("span").html($(event.currentTarget).text());
        }
        this.getProjectData();
      },
        clickTag: function (event) {
        $(event.currentTarget).addClass("on").siblings().removeClass('on');
        if ($(event.currentTarget).text() == "全部") {
          delete requestSearch.tagcode;
          $(".search-nav-item.redianbiaoqian").css("display", "none").find("span").html("");
        } else {
          requestSearch.tagcode = $(event.currentTarget).attr("data-code");
          $(".search-nav-item.redianbiaoqian").css("display", "inline-block").find("span").html($(event.currentTarget).text());
        }
        this.getProjectData();
      },
      clickNew: function (event) {
        $(event.currentTarget).addClass("active").siblings().removeClass('active');
        delete requestSearch.pricesort;
        delete requestSearch.isHot;
        this.getProjectData();
      },
      clickHot: function (event) {
        $(event.currentTarget).addClass("active").siblings().removeClass('active');
        delete requestSearch.pricesort;
        requestSearch.isHot = 1;
        this.getProjectData();
      },
      clickPriceSort: function (event) {
        $(event.currentTarget).addClass("active").siblings().removeClass('active');
        if ($(event.currentTarget).find("i").hasClass("down")) {
          requestSearch.pricesort = "asc";
          $(event.currentTarget).find("i").removeClass("down").addClass("up");
        } else {
          requestSearch.pricesort = "desc";
          $(event.currentTarget).find("i").removeClass("up").addClass("down");
        }
        delete requestSearch.isHot;
        this.getProjectData();
      },
      clickClose0:function (event) {
        //点击关闭搜索条件
        requestSearch.searchText = "";
        $(".search-nav-item.searchText").css("display", "none").find("span").html("");
        this.getProjectData();
      },
      clickClose1: function (event) {
        //点击关闭搜索条件
        delete requestSearch.zone;
        $(".search-nav-item.province").css("display", "none").find("span").html("");
        $(".sheng").find("a.on").removeClass("on");
        $(".sheng").find("li").eq(0).find("a").addClass("on");
        this.getProjectData();
      },
      clickClose2: function (event) {
        delete requestSearch.classify;
        $(".search-nav-item.hungaifangshi").css("display", "none").find("span").html("");
        $(".dd-hungaifangshi").find("a.on").removeClass("on");
        $(".dd-hungaifangshi").find("a").eq(0).addClass("on");
        this.getProjectData();
      },
      clickClose3: function (event) {
        delete requestSearch.minpercent;
        delete requestSearch.maxpercent;
        $(".search-nav-item.touzibili").css("display", "none").find("span").html("");
        $(".dd-touzibili").find("a.on").removeClass("on");
        $(".dd-touzibili").find("a").eq(0).addClass("on");
        this.getProjectData();
      },
      clickClose4: function (event) {
        delete requestSearch.minprice;
        delete requestSearch.maxprice;
        $(".search-nav-item.touzijine").css("display", "none").find("span").html("");
        $(".dd-touzijine").find("a.on").removeClass("on");
        $(".dd-touzijine").find("a").eq(0).addClass("on");
        this.getProjectData();
      },
      clickClose5: function (event) {
        delete requestSearch.state;
        $(".search-nav-item.xiangmuzhuangtai").css("display", "none").find("span").html("");
        $(".dd-xiangmuzhuangtai").find("a.on").removeClass("on");
        $(".dd-xiangmuzhuangtai").find("a").eq(0).addClass("on");
        this.getProjectData();
      },
      clickClose6: function (event) {
        delete requestSearch.industry;
        $(".search-nav-item.hangyefenlei").css("display", "none").find("span").html("");
        $(".dd-hangyefenlei").find("a.on").removeClass("on");
        $(".dd-hangyefenlei").find("a").eq(0).addClass("on");
        this.getProjectData();
      },
      clickClose7: function (event) {
        delete requestSearch.tagcode;
        $(".search-nav-item.redianbiaoqian").css("display", "none").find("span").html("");
        $(".dd-redianbiaoqian").find("a.on").removeClass("on");
        $(".dd-redianbiaoqian").find("a").eq(0).addClass("on");
        this.getProjectData();
      },
      clickClose8: function (event) {
        delete requestSearch.orgid;
        $(".search-nav-item.jigou").css("display", "none").find("span").html("");
        $(".dd-jigou").find("a.on").removeClass("on");
        $(".dd-jigou").find("a").eq(0).addClass("on");
        this.getProjectData();
      },
      clickSearch(){
        var searchText = $.trim($('#searchText').val());
        searchText = searchText.replace(/<\/?[^>]*>/g,'');//过滤特殊符号
        if(searchText!=""){
          requestSearch.searchText = searchText;
          $(".search-nav-item.searchText").css("display", "inline-block").find("span").html(searchText);
          this.getProjectData();
        }

        /*this.$router.push({
          path: '/select',
          query:{searchText:searchText}
        })*/
      },
      scrollEnd(e) {
        // console.log(document.documentElement.clientHeight+'-----------'+window.innerHeight); // 可视区域高度
        // console.log(document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop); // 滚动高度
        // console.log(document.body.offsetHeight); // 文档高度

        e = e || window.event;
        if (e.wheelDelta) {  //判断浏览器IE，谷歌滑轮事件
          if (e.wheelDelta > 0) { //当滑轮向上滚动时
            // alert("滑轮向上滚动");
          }
          if (e.wheelDelta < 0) { //当滑轮向下滚动时
            //alert("滑轮向下滚动");
            // 判断是否滚动到底部
            var scrollTopHeight = parseInt(document.documentElement.scrollTop);
            var scrollTopBodyHeight = parseInt(document.body.scrollTop);
            var offsetHeight = document.body.offsetHeight;
            if (( scrollTopHeight|| parseInt(window.pageYOffset) || scrollTopBodyHeight) + window.innerHeight >= offsetHeight-20) {
              if (this.noMore) {
                return false;
              }
              if (!this.lock) {
                this.lock = true;//锁住
                this.getMore();
              }
            }

          }
        } else if (e.detail) {  //Firefox滑轮事件
          if (e.detail> 0) { //当滑轮向上滚动时
            //alert("滑轮向上滚动");
            // 滚动的高度
            var scrollTopHeight = parseInt(document.documentElement.scrollTop);
            var scrollTopBodyHeight = parseInt(document.body.scrollTop);
            var offsetHeight = document.body.offsetHeight;
            if (( scrollTopHeight|| parseInt(window.pageYOffset) || scrollTopBodyHeight) + window.innerHeight >= offsetHeight-20) {
              if (this.noMore) {
                return false;
              }
              if (!this.lock) {
                this.lock = true;//锁住
                this.getMore();
              }
            }

          }
          if (e.detail< 0) { //当滑轮向下滚动时
            //alert("滑轮向下滚动");
          }
        }
      },
      getMore() {
        // 获取更多列表，就是后台提供的获取列表接口
        var _this = this;
        requestSearch.pageIndex = requestSearch.pageIndex + 1;
        $("#projectPromptInfo").html("数据加载中...");

        this.$http.jsonp(_this.projectUrl, {
          params: requestSearch,
          type: 'post'
        }).then(function (response) {
          if (response.body.msg == 200) {
            delete requestSearch.start;
            _this.item = _this.item.concat(response.body.result.data);
            $("#projectPromptInfo").html("");
            //_this.page++;

            if (requestSearch.pageIndex == response.body.result.totalPage) {
              _this.noMore = true;//没有更多了
              $("#projectPromptInfo").html("------没有更多了------");
            }
          } else {
            console.log('获取列表信息失败，请重试');
          }
        }).catch(function (error) {
          console.log(error);
        }).finally(function () {
          _this.lock = false;//解锁
        });

        //this.$http.post(_this.projectUrl,requestSearch)
      },
      getProjectData() {
        let _this = this;
        if (_this.$route.query.searchText != "" && _this.$route.query.searchText != undefined) {
          requestSearch.searchText = _this.$route.query.searchText
        }
        requestSearch.pageIndex = 1;//页码重置为1
        $("#projectPromptInfo").html("");
        _this.noMore = false;
        this.$http.jsonp(_this.projectUrl, {
          params: requestSearch,
          type: 'post'
        }).then(function (response) {
          if (response.body.msg == 200) {
            delete requestSearch.start;
            //console.log(response.body.result.sql_Debug);
            _this.total = response.body.result.totalData;
            _this.item = response.body.result.data;

            if (response.body.result.totalPage==0 || response.body.result.totalPage==1) {
              //总页数为0或1，则没有更多了
              _this.noMore = true;//没有更多了
            }

            //_this.page++;
          } else {
            if (response.body.result.data.length == 0) {
              //_this.noMore = true;//没有更多了
            } else {
              console.log('获取列表信息失败，请重试');
            }
          }
        }).catch(function (error) {
          console.log(error);
        }).finally(function () {
        });
      },
      toTop:function () {
        $("html,body").animate({
          scrollTop: 0
        }, 500);
      },
      clickMore:function(event){
        if ($(event.currentTarget).next().height() > 100) {
          $(event.currentTarget).find("i").removeClass("up").addClass("down");
          $(event.currentTarget).next().css({"height": "46px", "overflow": "hidden"});
        } else {
          $(event.currentTarget).find("i").removeClass("down").addClass("up");
          $(event.currentTarget).next().css({"height": "114px"});
        }
      },
      clickMoreJigou:function(event){
        if ($(event.currentTarget).next().height() > 100) {
          $(event.currentTarget).find("i").removeClass("up").addClass("down");
          $(event.currentTarget).next().css({"height": "46px", "overflow": "hidden"});
        } else {
          $(event.currentTarget).find("i").removeClass("down").addClass("up");
          $(event.currentTarget).next().css({"height": "auto"});
        }
      }
    },
    filters: {
      dateFormat: function (time) {
        return global.dateFormat(time)
      },
      maxLength50:function(val){
        return global.maxLength50(val)
      },
      filPercent:function(val){
        return global.filPercent(val)
      }
    },
    updated: function () {
      //根据url中的查询条件改变样式
    }
  }

  //全局变量
  var requestSearch = {};

    requestSearch.start = "",
    requestSearch.minPrice = "",
    requestSearch.maxPrice = "",

    requestSearch.isHot = "",
    requestSearch.searchText = "",
    requestSearch.industry = "",//行业分类A,B,C,D
    requestSearch.minpercent = "",
    requestSearch.maxpercent = "",
    requestSearch.state = "",//项目状态A01,A02
    requestSearch.classify = "",//混改方式C01,C02
      requestSearch.tagcode = "",//热点标签
      requestSearch.token = global.token,
      requestSearch.orgloc = global.orgid,//本地机构id
    requestSearch.orgid = '',
    requestSearch.pricesort = '',
    requestSearch.pageIndex = 1,//页码
    requestSearch.pageSize = "10",//默认每页12条
    requestSearch.zone = '';


  $(function () {

    //价格区间样式
    if (requestSearch.minPrice != "" && requestSearch.minPrice == 0) {
      $(".N-select-price .price1").addClass("on");
    } else if (requestSearch.minPrice != "" && requestSearch.minPrice == 1000000) {
      $(".N-select-price .price2").addClass("on");
    } else if (requestSearch.minPrice != "" && requestSearch.minPrice == 10000000) {
      $(".N-select-price .price3").addClass("on");
    } else if (requestSearch.minPrice != "" && requestSearch.minPrice == 50000000) {
      $(".N-select-price .price4").addClass("on");
    }


    $("body").click(function (e) {
      e.stopPropagation(e);
      var e = e || window.event; //浏览器兼容性
      var elem = e.target || e.srcElement;
      while (elem) { //循环判断至跟节点，防止点击的是div子元素
        if (elem.className && elem.className == 'share') {
          return;
        }
        elem = elem.parentNode;
      }
      //隐藏二维码
      $(".erweima-div").css("display","none");
    });

  });


</script>

<style scoped>
  @import "../style/common.css";
</style>
<style lang="stylus">
  .select {
    background: #fff;

  .news {
    min-height: 500px;
    padding: 0 10px;

  .new {
    height: 100px;
    color: #262627;
    border-bottom: 1px solid #eee;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: 100%;

  img {
    height: 80px;
    width: 100px;
  }

  .intro {
    width: 80%;
    height: 80px;
    display: flex;
    padding-left: 10px;
    flex-direction: column;
    justify-content: space-between;

  h4 {
    font-size: 20px;
    line-height: 1.2;
    font-weight: bold;
    overflow: hidden;
    display: -webkit-box;
    word-break: break-all;
    -webkit-line-clamp: 2;
    text-overflow: ellipsis;
    -webkit-box-orient: vertical;
  }

  p {
    font-size: 13px;
    color: #666;
  }
  }
  }

  .loadMore {
    height: 50px;
    width: 100%;
    color: #545454;
    background: #eee;
    text-align: center;
    line-height: 50px;
    font-size: 13px;
    border: none;
    border-radius: 0;
    outline: none;
    margin-bottom: 10px;
  }

  .fail {
    display: flex;
    min-height: 300px;
    align-items: center;
    justify-content: center;
  }
  }
  }

  /*加载动画*/
  .spinner {
    position: fixed;
    left: 40%;
    bottom: 10%;
    width: 80px;
    height: 80px;
    margin: 50px auto;
    background-color: #69C61D
    border-radius: 100%;
  }

  .goTop {
    color: #50BFFF;
    position: fixed;
    bottom: 40px;
    right: 20px;
    z-index: 9999;
    cursor: pointer;
    width: 60px;
    height: 60px;
    transition: all 1s ease;
    transform: scale(0.6);
  }

  .goTop:active {
    color: #C40000;
    transform: scale(1);
  }

  .fade-enter-active, .fade-leave-active {
    transition: opacity 0.8s
  }

  .fade-enter, .fade-leave-active {
    opacity: 0
  }

  .tip {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;

  a {
    color: #19C8A9;
  }

  span {
    margin-bottom: 10px;
  }
  }
</style>



// WEBPACK FOOTER //
// src/components/Select.vue